import Vue from 'vue';
import { extend } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules';
import { ValidationProvider } from 'vee-validate';
import i18n from '@/plugins/i18n';
Vue.component('ValidationProvider', ValidationProvider);

extend('required', {
  ...required,
  ...{
    message: _ => `${i18n.t('fieldRequired')}`,
  },
});

extend('email', {
  ...email,
  ...{
    message: _ => `${i18n.t('invalidEmail')}`,
  },
});

extend('number', {
  ...numeric,
  ...{
    message: _ => `${i18n.t('invalidPhoneNumber')}`,
  },
});
//TODO: add more rules when ready
